import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { DSTypography } from '../../mui';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const StyledDiv = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: rgba(250, 250, 250, 0.75) !important;

    border-radius: 20px;

    pointer-events: none;

    animation: ${fadeIn} ease 1s;
`;

export type ReportMessageProps = {
  children?: React.ReactNode;
};

export const ReportMessage: React.FC<ReportMessageProps> = ({ children }) => (
    <StyledDiv>
        <DSTypography variant="h4">
            {children}
        </DSTypography>
    </StyledDiv>
);
ReportMessage.displayName = 'ReportMessage';
